import React, { useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import IotService from "./Services/iotService";
import { LoadingToast, UpdateToastFailed, UpdateToastSuccess, errorNotification } from "../Generic/Notifications";
import Gantry from "./Godmode/Gantry";
import Dispensers from "./Godmode/Dispensers";
import Mircowave from "./Godmode/Mircowave";
import DI from "./Godmode/DI";
import DisposalSystem from "./Godmode/DisposalSystem";
import ConsumerShutter from "./Godmode/ConsumerShutter";
import Cooling from "./Godmode/Cooling";
import Chef from "./Godmode/Chef";
import Door from "./Godmode/Door";

const Page = styled.div`
	position: relative;
	height: max-content;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: left;
	padding: 2rem;
	@media (max-width: 1000px) {
		padding: 2rem;
	}
`;

export const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const PageHeading = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	height: max-content;
`;

const Header = styled.div`
	display: flex;
	font-size: 26px;
`;

const TabContain = styled.div`
	background: #fff;
	display: flex;
	width: max-content;
	align-items: center;
	padding: 0 0;
	margin: 1rem 0 1.5rem 0;
	border-radius: 10px;
`;

const Tab = styled.div`
	margin: 0;
	padding: 1rem;
	width: max-content;
	display: flex;
	z-index: 10;
	background: transparent;
	transition: 0.3s all linear;
`;

export const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 1rem;
	height: max-content;
	width: 100%;
`;

export const ScrollableContainer = styled.div`
	height: 100%;
	overflow-y: scroll;
`;

const ActiveTabContain = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: 100%;
	gap: 1.5rem;
`;

export const InputContain = styled.div`
	display: flex;
	flex-direction: column;
	margin: ${(props) => props.margin || "1rem 0 0 0"};
	width: ${(props) => props.width || "100%"};
`;

export const Center = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: max-content;
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	height: max-content;
	width: max-content;
	gap: 1rem;
`;

export const Divider = styled.div`
	border-top: 1px solid rgba(0, 0, 0, 0.2);
	width: 80%;
`;

function getTabs(sendTask, kitchenId, loadingStates) {
	return {
		CHEF: {
			headerText: "Chef",
			component: <Chef sendTask={sendTask} loadingStates={loadingStates} />
		},
		DOOR: {
			headerText: "Door",
			component: <Door sendTask={sendTask} loadingStates={loadingStates} />
		},
		GANTRY: {
			headerText: "Gantry",
			component: <Gantry sendTask={sendTask} loadingStates={loadingStates} />,
		},
		DISPENSERS: {
			headerText: "Dispensers",
			component: <Dispensers sendTask={sendTask} kitchenId={kitchenId} loadingStates={loadingStates} />,
		},
		MICROWAVE: {
			headerText: "Microwave",
			component: <Mircowave sendTask={sendTask} loadingStates={loadingStates} />,
		},
		DI: {
			headerText: "DI",
			component: <DI sendTask={sendTask} loadingStates={loadingStates} />,
		},
		DISPOSAL_SYSTEM: {
			headerText: "Disposal System",
			component: <DisposalSystem sendTask={sendTask} loadingStates={loadingStates} />,
		},
		CONSUMER_SHUTTER: {
			headerText: "Consumer Shutter",
			component: <ConsumerShutter sendTask={sendTask} loadingStates={loadingStates} />,
		},
		COOLING: {
			headerText: "Cooling",
			component: <Cooling sendTask={sendTask} loadingStates={loadingStates} />,
		},
	};
}

const GodMode = (props) => {
	const { kitchenId, machineID } = props;
	const [activeTab, toggleTab] = useState("CHEF");
	const [loadingStates, setLoadingStates] = useState({});

	// Create sendTask function inside the component
	async function sendTask(taskConfig, payload, successCallback = null) {
		const { taskType, name } = taskConfig;
		
		// Set loading state using taskType
		setLoadingStates(prev => ({ ...prev, [taskType]: true }));
		
		// Show loading toast with human readable name
		const toastId = LoadingToast(`${name} in progress`);
		const taskResponse = await IotService.sendTask(kitchenId, machineID, taskType, payload);
		const { data, error } = taskResponse;
		
		if (error) {
			errorNotification(error);
			UpdateToastFailed(`Failed to ${name}`, toastId);
		} else if (data) {
			if(successCallback) { successCallback(); }
			UpdateToastSuccess(`${name} sent`, toastId);
		}
		
		setLoadingStates(prev => ({ ...prev, [taskType]: false }));
	}

	const Tabs = getTabs(sendTask, kitchenId, loadingStates);

	function renderTabHeaders(Tabs, activeTab) {
		let renderData = [];
		for (const tab in Tabs) {
			const { headerText } = Tabs[tab];
			renderData.push(
				<Tab
					onClick={() => {
						toggleTab(tab);
					}}
					id={tab}
					className={tab === activeTab ? "tab active-tab" : "tab"}>
					{headerText}
				</Tab>
			);
		}
		return renderData;
	}

	function renderActiveTabComponent(activeTab) {
		if (!activeTab || !(activeTab in Tabs)) return;
		return <ActiveTabContain>{Tabs[activeTab].component}</ActiveTabContain>;
	}

	return (
		<Page>
			<PageHeading>
				<Header>Godmode</Header>
			</PageHeading>

			<TabContain id="contain">{renderTabHeaders(Tabs, activeTab)}</TabContain>

			<ScrollableContainer>{renderActiveTabComponent(activeTab)}</ScrollableContainer>
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { kitchen, landing } = state;
	return {
		kitchenId: landing.kitchenId,
		machineID: landing.machineID,
		...kitchen,
	};
};

export default connect(mapStateToProps, {})(GodMode);
